import { LocationTypeModel } from "../../shared/common/viewmodels/locationType.model";

export class LocationViewModel {
  id = 0;
  name = '';
  description = '';
  locationTypeId?: number;
  locationTypeName = '';
  locationType?: string = '';
  locationTypes: LocationTypeModel[];
  active = false;
}
